import { render, staticRenderFns } from "./chatTalkItem.vue?vue&type=template&id=71a855ef&scoped=true"
import script from "./chatTalkItem.vue?vue&type=script&lang=ts"
export * from "./chatTalkItem.vue?vue&type=script&lang=ts"
import style0 from "./chatTalkItem.vue?vue&type=style&index=0&id=71a855ef&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a855ef",
  null
  
)

export default component.exports